import { Model, NeoModel } from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import { AppService, Types } from '../../../../App/Services/AppService';
import RawGenericTransactionLookup from '../../Models/Lookups/RawGenericTransactionLookup';
import UpdateCashTransactionCommand from '../../Models/Commands/UpdateCashTransactionCommand';
import StaticEventLookup from '../../../EventMapping/Models/StaticEventSearchModal/StaticEventLookup';

@NeoModel
export default class UpdateCashTransactionComponentVM extends Views.ViewModelBase {

    constructor(
        public instrumentApiCient = AppService.get(Types.ApiClients.InstrumentApiClient),
        public authorisationService = AppService.get(Types.Neo.Security.AuthorisationService),
        public taskRunner = AppService.get(Types.Neo.TaskRunner)) {
        super(taskRunner);
    }

    public updateCashTransactionCommand = new UpdateCashTransactionCommand();
    public selectedCashTransactions: RawGenericTransactionLookup[] = [];

    public events: Model.PlainObject<StaticEventLookup>[] = [];
    public filteredEvents: Model.PlainObject<StaticEventLookup>[] = [];

    public clearInputs() { 
        this.updateCashTransactionCommand.newStaticEventID = null;
    }
}